import { render } from "./BlogAddComment.vue?vue&type=template&id=05de0f52&scoped=true"
import script from "./BlogAddComment.vue?vue&type=script&lang=js"
export * from "./BlogAddComment.vue?vue&type=script&lang=js"

import "./BlogAddComment.vue?vue&type=style&index=0&id=05de0f52&scoped=scoped&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05de0f52"]])

export default __exports__